<template>
  <div class="content-confirm">
    <AppHeader title="上机确认"/>
    <div class="booking-inf" v-if="booking">
      <div class="eq-title">{{ booking.equipment.name }}</div>
      <div class="eq-img" v-if="booking.equipment.avatar"><img :src="`${this.imgUrl}/${booking.equipment.avatar}`" class="eq-img" /></div>
      <div class="eq-img" v-else>没有图片</div>
      <div class="booking-desc">
        <div class="booking-desc-line"><span>存放地点:</span>{{ booking.equipment.eqLocation }}</div>
        <div class="booking-desc-line"><span>预约时间: </span>{{ beginEnd(booking.beginAt, booking.endAt)}}</div>
        <div class="booking-desc-line"><span>当前时间: </span>{{ this.$moment().format('YYYY.MM.DD HH:mm') }}</div>
        <div class="booking-desc-line"><span>当前状态: </span><span class="eq-status">待机中</span></div>
      </div>
    </div>
    <div class="content">
      <div class="btn green" @click="startExp">确认上机</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.eq-status {
  font-size: 15px;
  font-weight: bold;
  color: #F86719 !important;
}

.booking-desc {
  margin-top: 20px;
  width: 100%;
}

.booking-inf {
  padding: 15px 20px;
  background: #fff;
  border-radius: 5px;
  margin: 50px 20px 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.content-confirm {
  margin: 0;
  background: linear-gradient(#31B8D3, #1682A7);
}

.eq-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333333;
}

.eq-img {
  width: 240px;
  height: 240px;
  line-height: 240px;
  align-self: center;
  border-radius: 5px;
  border: 1px solid #E6E6E6;
  background: RGBA(67, 74, 84, .9);
  color: #fff;
  text-align: center;
  font-size: 16px;
}

.booking-desc-line {
  font-size: 15px;
  color: #666;
  display: flex;
  align-items: center;
  margin-top: 10px;
  span {
    font-weight: bold;
    color: #333;
    padding-right: 5px;
  }

  &:first-child{
    margin-top: 0;
  }
}
</style>
<script>
import AppHeader from "@/components/AppHeader";
import Panel from "@/components/Panel";
import {MessageBox, Toast} from 'mint-ui';
import store from "@/plugins/store";

export default {
  components: {
    AppHeader,
    Panel
  },
  data() {
    return {
      booking: null
    }
  },
  methods: {
    beginEnd(beginAt, endAt) {
      let beginYMD = this.$moment(beginAt).format('YYYY.MM.DD')
      let result = this.$moment(beginAt).format('YYYY.MM.DD HH:mm')
      if (endAt) {
        let endYMD = this.$moment(endAt).format('YYYY.MM.DD')
        if (endYMD == beginYMD) {
          result += ("-" + this.$moment(endAt).format('HH:mm'))
        } else {
          result += ("-" + this.$moment(endAt).format('YYYY.MM.DD HH:mm'))
        }
      } else {
        result += "-"
      }
      return result
    },
    startExp(){
      const that = this
      var eqId=that.$route.query.equipmentId
      this.$http.post(`/api/booking/start?id=${this.booking.id}&withoutHeartbeat=true`).then(res=>{
        // that.$router.push("/exp")
        that.$router.push({
          path: '/exp',
          query: {
            equipmentId: eqId,
            bookingId: this.booking.id
          }
        })
      })
    }
  },
  mounted() {
    this.booking = store.getters.curBooking
    console.log(this.booking)
  }
}
</script>